import {
    BatchWriteItemCommand,
    DynamoDBClient,
    QueryCommand,
    QueryCommandInput,
    WriteRequest,
} from '@aws-sdk/client-dynamodb'

import { REGION } from 'src/services/aws/credentials'

export interface ClientConfiguration {
    accessKeyId: string
    secretAccessKey: string
    sessionToken: string
}

export class DDBHandler {
    private readonly ddbTable: string

    constructor(ddbTable: string) {
        this.ddbTable = ddbTable
    }

    /* istanbul ignore next */
    getClient(config: ClientConfiguration) {
        return new DynamoDBClient({
            region: REGION,
            credentials: config,
        })
    }

    async loadResults(keyName: string, keyValue: string, config: ClientConfiguration) {
        const client = this.getClient(config)
        const params: QueryCommandInput = {
            TableName: this.ddbTable,
            KeyConditionExpression: '#keyName = :keyValue',
            ExpressionAttributeValues: {
                ':keyValue': { S: keyValue },
            },
            // ExpressionAttributeNames is required because we have used a specific primary key
            ExpressionAttributeNames: {
                '#keyName': keyName,
            },
        }
        return await client.send(new QueryCommand(params))
    }

    async batchWrite(requests: WriteRequest[], config: ClientConfiguration) {
        const client = this.getClient(config)
        return await client.send(
            new BatchWriteItemCommand({
                RequestItems: {
                    [this.ddbTable]: requests,
                },
            })
        )
    }
}
